export default __webpack_public_path__ + "static/media/copy-btn.1a9878ea.svg";